import * as React from "react";
import styled, { css } from "styled-components";
import { HoverForHelp, AccessibleCard } from "components/common";
const Card = styled(AccessibleCard)(
  ({ theme, $variant }) => css`
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    min-width: 100px;
    padding: ${theme.spacings.md};
    color: inherit;
    font: inherit;
    ${$variant !== "default" && css`
      border-left: 3px solid ${theme.colors.variant[$variant]};
    `}
    position: relative;
  `
);
const HelpCorner = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.spacings.xs};
    right: ${theme.spacings.xs};
    color: ${theme.colors.text.secondary};
    font-size: 0.7em;
  `
);
const CardLabel = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    font-size: ${theme.fonts.size.small};
    font-weight: 600;
  `
);
const CardValue = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    font-size: ${theme.fonts.size.huge};
    font-weight: 700;
    line-height: 1.2;
    overflow-wrap: anywhere;
  `
);
const CardSubValue = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    font-size: ${theme.fonts.size.small};
  `
);
const StatCard = ({
  value,
  label,
  subValue = null,
  helpText = void 0,
  variant = "default",
  onClick = void 0,
  className = void 0
}) => /* @__PURE__ */ React.createElement(Card, { $variant: variant, onClick, className }, helpText && /* @__PURE__ */ React.createElement(HelpCorner, null, /* @__PURE__ */ React.createElement(HoverForHelp, { title: label, triggerTitle: "More info", placement: "right", pullRight: false }, helpText)), /* @__PURE__ */ React.createElement(CardLabel, null, label), /* @__PURE__ */ React.createElement(CardValue, null, value), /* @__PURE__ */ React.createElement(CardSubValue, null, subValue));
export default StatCard;
